import { Button, Collapse, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Link, useParams } from "react-router-dom";
import uuid from "react-uuid";
import ProfileImg from "../../../../../shared/ui/icons/ProfileImg";

type Props = {
  accountIds: string[],
};

const AccountInfo = ({ accountIds }: Props) => {
  const { viewId }: any = useParams();
  const [opened] = useDisclosure(true);
  const [showAllAccounts, { toggle: toggleShowAllAccounts }] = useDisclosure(false);
  
  // Show only first 3 accounts initially
  const visibleAccounts = accountIds?.slice(0, 6) || [];
  const remainingAccounts = accountIds?.slice(6) || [];
  const hasMoreAccounts = remainingAccounts.length > 0;

  return (
      <Collapse in={opened}>
        <div className="py-2 px-2">
          {accountIds?.length ? (
            <>
              <div className="grid grid-cols-3 gap-1">
                {visibleAccounts.map((item: any) => (
                  <Link 
                    key={uuid()} 
                    to={`../view/${viewId}/account/${item?.external_id}/overview`} 
                    className="flex flex-col items-center py-2 px-1 hover:bg-gray-50 rounded-sm transition-colors duration-150 text-center"
                  >
                    <div className="flex-shrink-0 mb-1">
                      <ProfileImg size="md" name={item?.name} img={item?.avatar_url} />
                    </div>
                    <div className="w-full">
                      <Text size="xs" fw={500} className="capitalize" c="text.6" truncate>
                        {item?.name}
                      </Text>
                    </div>
                  </Link>
                ))}
              </div>
              
              <Collapse in={showAllAccounts}>
                <div className="grid grid-cols-3 gap-1 mt-1">
                  {remainingAccounts.map((item: any) => (
                    <Link 
                      key={uuid()} 
                      to={`../view/${viewId}/account/${item?.external_id}/overview`} 
                      className="flex flex-col items-center py-2 px-1 hover:bg-gray-50 rounded-sm transition-colors duration-150 text-center"
                    >
                      <div className="flex-shrink-0 mb-1">
                        <ProfileImg size="md" name={item?.name} img={item?.avatar_url} />
                      </div>
                      <div className="w-full">
                        <Text size="xs" fw={500} className="capitalize" truncate>
                          {item?.name}
                        </Text>
                      </div>
                    </Link>
                  ))}
                </div>
              </Collapse>
              
              {hasMoreAccounts && (
                <div className="flex justify-center mt-2">
                  <Button
                    variant="subtle"
                    size="xs"
                    onClick={toggleShowAllAccounts}
                    c="dimmed"
                  >
                    {showAllAccounts ? 'See less' : `See more (${remainingAccounts.length})`}
                  </Button>
                </div>
              )}
            </>
          ) : (
            <Text className="text-gray-500 p-4">No Accounts linked to this User</Text>
          )}
        </div>
      </Collapse>
  );
};

export default AccountInfo;
